import { useEffect, useRef, useState } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { api } from "@/lib/api";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AppShell from "@/components/AppShell";
import { ChangePassword } from "@/components/ChangePassword";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function GoogleCallback({ onLogin, onFail }) {
  const processed = useRef(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState({}, "", window.location.pathname);
    if (!sessionId) { onFail(); return; }
    api("/auth/google/session", { method: "POST", body: JSON.stringify({ session_id: sessionId }) })
      .then(onLogin)
      .catch((e) => setError(e.message));
  }, []); // eslint-disable-line
  if (error) return (
    <div className="loading-screen" data-testid="google-auth-error">
      <div className="google-cb-error">
        <p>{error}</p>
        <button className="primary-btn" onClick={onFail}>Kembali ke Halaman Masuk</button>
      </div>
    </div>
  );
  return <div className="loading-screen" data-testid="google-auth-loading">Menyambungkan akun Google Anda...</div>;
}

function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const hasGoogleSession = window.location.hash.includes("session_id=");
  const hasResetToken = new URLSearchParams(window.location.search).has("reset_token");
  const [view, setView] = useState(hasResetToken ? "auth" : "landing");
  const [authMode, setAuthMode] = useState("login");
  const [googleFlow, setGoogleFlow] = useState(hasGoogleSession);
  useEffect(() => {
    if (hasGoogleSession) { setChecking(false); return; }
    api("/auth/me").then(setUser).catch(() => setUser(false)).finally(() => setChecking(false));
  }, []); // eslint-disable-line
  const [landing, setLanding] = useState(null);
  useEffect(() => { api("/public/landing").then(setLanding).catch(() => {}); }, []);
  if (googleFlow && !user) return <GoogleCallback onLogin={(u) => { setUser(u); setGoogleFlow(false); }} onFail={() => { setGoogleFlow(false); setUser(false); setView("auth"); setAuthMode("login"); }} />;
  if (checking) return <div className="loading-screen" data-testid="auth-loading">Memuat workspace...</div>;
  if (!user) {
    if (view === "landing") return <Landing content={landing} onEnter={(mode) => { setAuthMode(mode); setView("auth"); }} />;
    return <Login onLogin={setUser} initialMode={authMode} appName={landing?.app_name || "Kiyana IAC Solution"} onBack={() => setView("landing")} />;
  }
  const logout = () => api("/auth/logout", { method: "POST" }).then(() => { setUser(false); setView("landing"); setAuthMode("login"); });
  return (
    <BrowserRouter>
      <AppShell user={user} onLogout={logout} />
      {user.must_change_password && <ChangePassword onDone={() => setUser({ ...user, must_change_password: false })} onLogout={logout} />}
    </BrowserRouter>
  );
}

export default App;
